import script from "./LeadsPropertyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadsPropertyCard.vue?vue&type=script&setup=true&lang=js"

import "./LeadsPropertyCard.vue?vue&type=style&index=0&id=b73887de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b73887de"]])

export default __exports__